angular.module("vgresiduos").controller("MasterOrganizationEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `master/organizacao/${$stateParams.id}`);
		};
	}
]);
